module.exports = __webpack_public_path__ + "static/media/19.d0204cf0.png";